import { render, staticRenderFns } from "./GameChatLog.vue?vue&type=template&id=25707fc1"
import script from "./GameChatLog.vue?vue&type=script&lang=js"
export * from "./GameChatLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports